import { getHalfHourIntervalTimeCost } from '../utils';
import { resolveB2CRates } from '../constants';
import { CalculationData, CalculationStrategy } from './calculation-strategy';

export class CaregivingPhoneAssistanceStrategy implements CalculationStrategy {
  calculate(data: CalculationData) {
    const rates = resolveB2CRates(data.reservationCreationDate);

    if (
      !data.caregivingDuration &&
      typeof data.caregivingDuration !== 'number'
    ) {
      throw new Error('Caregiving duration is required');
    }

    const caregivingDuration =
      (rates.PHONE_ASSISTANCE_MIN_HOURS > data.caregivingDuration
        ? rates.PHONE_ASSISTANCE_MIN_HOURS
        : data.caregivingDuration) * 2;

    const timeCost = getHalfHourIntervalTimeCost(
      caregivingDuration,
      rates.PHONE_ASSISTANCE_PRICE_PER_HALF_HOUR
    );

    return {
      timeCost,
      caregivingDuration,
      totalCost: timeCost,
    };
  }
}
